import React from 'react';
import classnames from 'classnames';

import LogoSVG from '../svg/logo.svg';

function FooterMinimal({ isDark = false }) {
  const year = new Date().getFullYear();

  const wrapperClass = classnames('bg-transparent w-full', {
    'bg-haiti': isDark,
  });
  const footerClass =
    'flex flex-col items-center space-y-4 max-w-6xl mx-auto py-8 px-6 sm:space-y-0 sm:flex-row sm:justify-between';
  const containerClass = 'flex flex-row space-x-4 items-center';
  const textClass = classnames('text-base leading-6', {
    'text-whisper': isDark,
    'text-gray-500': !isDark,
  });
  const linkClass = classnames(textClass, 'hover:text-cornflower');
  const logoClass = classnames('h-8', {
    'text-white': isDark,
    'text-black': !isDark,
  });

  return (
    <div className={wrapperClass}>
      <footer className={footerClass}>
        <div className={containerClass}>
          <p className={textClass}>
            &copy; {year} <span className="sr-only">GraphCMS</span>
          </p>
          <LogoSVG className={logoClass} />
        </div>
        <nav className={containerClass}>
          <a href="/contact" target="_blank" className={linkClass}>
            Contact
          </a>

          <a href="/imprint" target="_blank" className={linkClass}>
            Imprint
          </a>
        </nav>
      </footer>
    </div>
  );
}

export default FooterMinimal;
